import produce from "immer";
import { AIReconciliationActions } from ".";
import { IStoreState } from "../initialStoreState";
import { initialAccountReconciliationState, initialPollingState } from "./aiReconciliation.types";
import {
  CLEAR_RECONCILIATION_DETAILS_STATE,
  FETCH_RECONCILIATION_DETAILS_FAILED,
  FETCH_RECONCILIATION_DETAILS_PROGRESS,
  FETCH_RECONCILIATION_DETAILS_SUCCESS,
  FETCH_RECONCILIATION_LIST_FAILED,
  FETCH_RECONCILIATION_LIST_PROGRESS,
  FETCH_RECONCILIATION_LIST_SUCCESS,
  RECONCILIATION_JOB_SUBMITTED,
  RECONCILIATION_POLLING_STATUS_UPDATED,
  RECONCILIATION_POLLING_FAILURE,
  RECONCILIATION_POLLING_FAILURE_RESET,
  RECONCILIATION_POLLING_RESET,
  RECONCILIATION_POLLING_PROGRESS_UPDATED,
} from "./aiReconciliationActions";
import { LoadState } from "../../constants/enums";




export const aiReconciliationReducer = (
  state: IStoreState["aiReconciliation"] = initialAccountReconciliationState,
  action: AIReconciliationActions
) => {
  switch (action.type) {
  
    case FETCH_RECONCILIATION_DETAILS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.reconciliationDetailsLoading = LoadState.InProgress;
        draftState.reconciliationDetails = initialAccountReconciliationState['reconciliationDetails'];
      });
      return newState;
    }
    case FETCH_RECONCILIATION_DETAILS_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.reconciliationDetailsLoading = LoadState.Loaded;
        draftState.reconciliationDetails = data;
      });
      return newState;
    }
    case FETCH_RECONCILIATION_DETAILS_FAILED: {
      const { error } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.reconciliationDetailsLoading = LoadState.Failed;
        draftState.reconciliationDetails =  initialAccountReconciliationState['reconciliationDetails'];
        draftState.reconciliationDetailsError = error;
      });
      return newState;
    }

    case FETCH_RECONCILIATION_LIST_PROGRESS: {
          const newState = produce(state, (draftState) => {
            draftState.loading = LoadState.InProgress;
            draftState.list = [];
            draftState.totalRecords = 0;
          });
          return newState;
        }
        case FETCH_RECONCILIATION_LIST_SUCCESS: {
          const { data, totalRecords } = action.payload;
          const newState = produce(state, (draftState) => {
            draftState.loading = LoadState.Loaded;
            draftState.list = data;
            draftState.totalRecords = totalRecords;
          });
          return newState;
        }
        case FETCH_RECONCILIATION_LIST_FAILED: {
          const newState = produce(state, (draftState) => {
            draftState.loading = LoadState.InProgress;
            draftState.list = [];
            draftState.totalRecords = 0;
          });
          return newState;
        }

    case RECONCILIATION_JOB_SUBMITTED: {
      const { processLogCode, status } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.polling.processLogCode = processLogCode;
        draftState.polling.pollingStatus = status as any;
        draftState.polling.pollingStartedAt = Date.now();
      });
      return newState;
    }
    case RECONCILIATION_POLLING_STATUS_UPDATED: {
      const { status, errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.polling.pollingStatus = status;
        if (errorMessage !== undefined) {
          draftState.polling.errorMessage = errorMessage ?? null;
        }
      });
      return newState;
    }
    case RECONCILIATION_POLLING_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.polling.consecutiveFailures += 1;
      });
      return newState;
    }
    case RECONCILIATION_POLLING_FAILURE_RESET: {
      const newState = produce(state, (draftState) => {
        draftState.polling.consecutiveFailures = 0;
      });
      return newState;
    }
    case RECONCILIATION_POLLING_RESET: {
      const newState = produce(state, (draftState) => {
        draftState.polling = initialPollingState;
      });
      return newState;
    }

    case RECONCILIATION_POLLING_PROGRESS_UPDATED: {
      const newState = produce(state, (draftState) => {
        draftState.polling.progress = action.payload;
      });
      return newState;
    }

    case CLEAR_RECONCILIATION_DETAILS_STATE: {
      return  initialAccountReconciliationState;
    }

    default: {
      return state;
    }
  }
};
